import { parentChildCommunication } from "./parentChildCommunication";

export const fundingSourceWrapper = {
    props: [
        "user",
        "organization",
        "invoices",
        "patients",
        "therapists",
        "sourceType",
        "pagination",
        "title",
        "fields",
        "loading",
    ],
    mixins: [parentChildCommunication],
    methods: {
        updateInvoice(event) {
            this.$emit("update-invoice", event);
        },
        moveInvoices(event) {
            this.$emit("move-invoices", event);
        },
        recoverInvoices(event) {
            this.$emit("recover-invoices", event);
        },
        fetchPage(event) {
            this.$emit("fetch-page", event);
        },
        localUpdateInvoice(event) {
            this.$emit("local-update", event);
        },
    },
};
